<template>
  <div>
    <mensajeSistema></mensajeSistema>
    <v-container v-if="verUnidad">
      <v-row>
        <v-col cols="12" class="d-flex justify-end">
          <ButtonComp @click="AddItem" text-button="Crear unidad" icon-but="fas fa-plus" normal-button />
        </v-col>
        <v-col cols="12" sm="6" md="2" lg class="py-0">
          <AutocompleteComp @change="FiltroPais(listPais)" v-model="listPais" textLabel="País" :items="api_mant_pais"
            item-value="id" item-text="nombre_pais" />
        </v-col>
        <v-col cols="12" sm="6" md="2" lg class="py-0">
          <AutocompleteComp @change="FiltroNivel(listNivel)" v-model="listNivel" textLabel="Nivel" :items="api_mant_nivel"
            item-value="id" item-text="desc_nivel" :disabled="disabledNivel" />
        </v-col>
        <v-col cols="12" sm="6" md="2" lg class="py-0">
          <AutocompleteComp @change="FiltroGrados(listGrado)" v-model="listGrado" textLabel="Grado"
            :items="api_mant_grado" item-value="id" item-text="desc_grado" :disabled="disabledGrado" />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg class="py-0">
          <AutocompleteComp @change="FiltroArea(listArea)" v-model="listArea" textLabel="Área" :items="api_mant_area"
            item-value="id" item-text="desc_area" :disabled="disabledArea" />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg class="py-0">
          <AutocompleteComp @change="FiltroCursos(listCurso)" v-model="listCurso" textLabel="Curso"
            :items="api_mant_curso" item-value="id" item-text="desc_curso" :disabled="disabledCurso" />
        </v-col>

        <v-col cols="12" class="d-flex justify-end">
          <v-text-field label="Buscar" v-model="busquedaValor" dense small append-icon="fa-search" single-line outlined
            style="max-width: 400px" hide-details @keyup="
              ((paginaActual = 1)),
              GetAllTemas()
              "></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-data-table dense :headers="GestionContenidosHeadersTema" :items="vis_tema" :options.sync="options"
            :server-items-length="totalregistros" :loading="loading" :footer-props="{
              'items-per-page-options': [5, 10, 20],
              'itemsPerPageText': 'Filas por página',  // Cambia esto al texto que desees
            }">
            <template v-slot:[`item.action_crear_clase`]="{ item }">
              <ButtonComp @click="ViewTema(item)" tooltipText="Ver temas" verButton />
            </template>

            <template v-slot:[`item.action_editar`]="{ item }">
              <ButtonComp @click="EditItem(item)" tooltipText="Editar Unidad" editButton />
            </template>

            <template v-slot:[`item.action_borrar`]="{ item }">
              <ButtonComp @click="ShowConfirmDeleteUnidad(item)" tooltipText="Eliminar unidad" deleteButton />

            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>

    <!-- confim para eliminar unidad -->
    <Confirm titleWindow="Eliminar unidad" title="¿Está seguro de que desea eliminar esta unidad?"
      :active="confirmDeleteUnidad" @aceptar="DeleteTema" @cancelar="CerrarConfirmDeleteUnidad" />

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal">
    </component>
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations } from "vuex";
import BtnComp from "@/components/ComponentsEst/BtnComp.vue";
import Confirm from "@/components/confirm";
import UnidadFormComp from "./componentes/unidadFormComp";
import TemaComp from "../tema/tema";
import AutocompleteComp from "@/components/ComponentsEst/AutocompleteComp.vue";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import { GestionContenidosHeadersTema } from "../../../../helpers/headersTable";



export default {
  name: "Unidad",
  // componentes
  components: {
    Confirm,
    UnidadFormComp,
    TemaComp,
    BtnComp,
    AutocompleteComp,
    ButtonComp,
    ComundataTablecomp

  },

  data() {

    return {
      mensaje: { tipo: null, mensaje: null, tiempo: null }, // mensaje de sistema
      ruta_api: API_URL,
      // PROPIEDADES DE PAGINACION
      paginaActual: 1,
      totalPaginas: 0,
      tamañoPorPagina: 10,
      tamañosPorPagina: [3, 6, 9],
      totalregistros: 0,
      busquedaValor: "",

      options: {},
      loading: true,

      // componente Fomulario
      compName: null,
      estadoComponente: true,
      parametroComp: [],
      GestionContenidosHeadersTema,

      verUnidad: true,

      confirmDeleteUnidad: false,
      unidadDelete: "",

      listPais: "",
      listNivel: "",
      listGrado: "",
      listArea: "",
      listCurso: "",

      vis_tema: [],
      api_mant_pais: [],
      api_mant_nivel: [],
      api_mant_area: [],
      api_mant_curso: [],
      api_mant_grado: [],

      disabledNivel: true,
      disabledGrado: true,
      disabledArea: true,
      disabledCurso: true,

      paramsTemas: {
        id_pais: "",
        id_nivel: "",
        id_grado: "",
        id_area: "",
        id_curso: "",
        id_tema: "",
      },



      //validaciones de formulario
      rul: {
        required: (value) => !!value || "Campo Requerido",
        inputReq: (value) => !!value || "Campo Requerido",
        selectReq: (value) =>
          !!value || "Debe seleccionar un campo de la lista",
        email: (value) =>
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
          "El correo Electrónico es incorrecto",
        min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
        min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
        min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
        max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
        max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
        max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
        max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
        max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
        max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
        max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
        max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
        max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",

        email_null: (value) => {
          if (value == "") {
            return false;
          } else {
            const pattern =
              /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
            return pattern.test(value) || "El correo Electrónico es incorrecto";
          }
        },
      },
    };
  },
  watch: {
    options: {
      handler(newValor, oldValor) {
        this.tamañoPorPagina = newValor.itemsPerPage;
        if (newValor.itemsPerPage != oldValor.itemsPerPage) {
          this.paginaActual = 1;
        }
        // this.paginaActual = 1;
        this.paginaActual = newValor.page;
        this.GetAllTemas();
      },
      deep: true,
    },

  },

  /// variables computadas
  computed: {
    titleModalTema() {
      return this.editar !== true ? "Crear Unidad" : "Editar Unidad";
    },
  },

  mounted() {
    this.LoadMain();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-- cargar Parametros de inicio del componente --
    async LoadMain() {
      this.GetAllTemas();
      this.GetPais();
    },

    /*----------------------------*/
    /* MÉTODO OBETENER PARAMETROS */
    /*----------------------------*/
    obtenerParametros(
      valorBusqueda,
      paginaActual,
      tamañoPorPagina,
      paramsTemas
    ) {
      let parametros = {};
      if (valorBusqueda) {
        parametros.valor = valorBusqueda;
      }
      if (paginaActual) {
        parametros.paginaActual = paginaActual - 1;
      }
      if (tamañoPorPagina) {
        parametros.tamañoPorPagina = tamañoPorPagina;
      }
      if (paramsTemas) {
        parametros = { ...parametros, ...paramsTemas };
      }
      return parametros;
    },

    /*********cargar temas segun seleccion de Nivel, grado, area , curso y tema */
    async GetAllTemas() {
      // this.vis_tema = [];
      this.loading = true
      const patrametosListar = this.obtenerParametros(
        this.busquedaValor,
        this.paginaActual,
        this.tamañoPorPagina,
        this.paramsTemas
      );
      // console.log({patrametosListar});
      try {
        const response = await axios.get("manager/tema/temas", { params: patrametosListar })

        if (response.data.message) {
          this.vis_tema = [];
        }
        else {
          let { filas, totalPaginas, totalFilas } = response.data.payload;
          this.vis_tema = filas;
          this.totalPaginas = totalPaginas;
          this.totalregistros = totalFilas;
        }
        this.loading = false
      } catch (error) {
        console.log(error);
      }
    },

    //************************************************************ */
    /////////////// Cargar todos los Paises //////////////////////////
    async GetPais() {
      try {
        let response = await axios.get("/manager/pais/");
        this.api_mant_pais = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    //************************************************************ */
    /////////////// Cargar todos los Niveles //////////////////////////
    async GetNivel() {
      try {
        let response = await axios.get("/manager/nivelCkOne/");
        this.api_mant_nivel = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    ////////////////////////////////////////////////////////////////
    ///////////////// Cargar los niveles segun el pais seleccionado  ///////////////////////////
    async FiltroPais(id) {
      this.paramsTemas.id_pais = id;
      this.paramsTemas.id_nivel = "";
      this.paramsTemas.id_grado = "";
      this.paramsTemas.id_area = "";
      this.paramsTemas.id_curso = "";

      //limpiamos los select
      this.api_mant_nivel = [];
      this.api_mant_grado = [];
      this.api_mant_area = [];
      this.api_mant_curso = [];
      try {
        const response = await axios.get(`/manager/nivelCkOne/pais/${id}`);
        this.api_mant_nivel = response.data;
        this.listArea = "";
        this.listCurso = "";
        this.paginaActual = 1;
        this.GetAllTemas();
        if (this.api_mant_nivel.length > 0) {
          this.disabledNivel = false;
          this.disabledArea = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    ////////////////////////////////////////////////////////////////
    ///////////////// Cargar los Grados  ///////////////////////////
    async FiltroNivel(id) {
      this.paramsTemas.id_nivel = id;
      this.paramsTemas.id_grado = "";
      this.paramsTemas.id_area = "";
      this.paramsTemas.id_curso = "";

      this.api_mant_grado = [];
      this.api_mant_area = [];
      this.api_mant_curso = [];
      try {
        const response = await axios.get(
          "/manager/gradoCkOne/grados/" + id + ""
        );
        this.api_mant_grado = response.data;
        this.listArea = "";
        this.listCurso = "";
        this.paginaActual = 1;
        this.GetAllTemas();
        if (this.api_mant_grado.length > 0) {
          this.disabledGrado = false;
          this.disabledArea = true;
          this.disabledCurso = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    ////////////////////////////////////////////////////////////////
    /////////////// seeccionar grados y habilitar cursos /////////
    /***********ejecutar temas por grados */
    async FiltroGrados(id) {
      this.paramsTemas.id_area = "";
      this.paramsTemas.id_curso = "";
      this.paramsTemas.id_grado = id;

      this.api_mant_area = [];
      this.api_mant_curso = [];

      this.listCurso = null;
      this.listArea = null;
      this.disabledCurso = true;
      this.paginaActual = 1;
      await this.GetArea(this.listNivel);
      await this.GetAllTemas();
    },
    //////////////////////////////////////////////////////////////
    ////////////  cargar areas  //////////////////////////////////
    async GetArea(id) {
      try {
        const response = await axios.get(`/manager/areaCkOne/nivel/${id}`);
        this.api_mant_area = response.data;
        if (this.api_mant_area.length > 0) {
          this.disabledArea = false;
        } else {
          this.disabledArea = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    ////////////////////////////////////////////////////////////
    ///////////////  cargar los cursos  ///////////////////////
    async FiltroArea(id) {

      this.paginaActual = 1;
      this.paramsTemas.id_curso = "";
      this.paramsTemas.id_area = id;
      this.api_mant_curso = [];

      let params = {
        id_area: id,
        id_grado: this.paramsTemas.id_grado,
        id_pais: this.paramsTemas.id_pais,
      };
      try {
        const response = await axios.post(
          "/manager/cursoCkOne/cursos/",
          params
        );
        this.api_mant_curso = response.data;
        if (this.api_mant_curso.length > 0) {
          this.disabledCurso = false;
        } else {
          this.disabledCurso = true;
        }
        this.GetAllTemas();
      } catch (e) {
        console.log(e);
      }
    },
    //////////////////////////////////////////////////////////////
    /////////////////  CARGAR TEMAS SEGUN CURSO /////////////////
    async FiltroCursos(id) {

      this.paginaActual = 1;
      this.paramsTemas.id_curso = id;
      await this.GetAllTemas();
    },
    /////////////////////////////////////////////////////////////

    ViewTema(item) {
      //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
      this.verUnidad = false;
      this.parametroComp = { evento: "view", item };
      this.compName = "TemaComp";
      this.estadoComponente = true;
    },

    AddItem() {
      //this.setEnviarMens({tipo:"W", mensaje: `Agregar Formulario`, tiempo:null})
      this.parametroComp = { evento: "add" };
      this.compName = "UnidadFormComp";
      this.estadoComponente = true;
    },

    EditItem(item) {
      // this.setEnviarMens({tipo:"W", mensaje: `Editar Formulario`, tiempo:null})
      this.parametroComp = { evento: "edit", item };
      this.compName = "UnidadFormComp";
      this.estadoComponente = true;
    },

    CloseModal() {
      this.estadoComponente = false;
      this.verUnidad = true;
      this.LoadMain();
    },

    ShowConfirmDeleteUnidad(item) {
      this.unidadDelete = item.id;
      this.confirmDeleteUnidad = true;
    },

    CerrarConfirmDeleteUnidad() {
      this.confirmDeleteUnidad = false;
    },

    async DeleteTema() {
      try {
        const { data } = await axios.put(
          `/manager/tema/dt/inac/${this.unidadDelete}`
        );
        this.GetAllTemas();
        this.setEnviarMens({
          tipo: data.messageT,
          mensaje: data.message,
          tiempo: null,
        });
        this.unidadDelete = "";
        this.CerrarConfirmDeleteUnidad();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>

